




















import {Component, Prop, Vue} from "vue-property-decorator";
import {MeetingPanelTabs} from "@mixins/models/MeetingPanelTabs";
import BannerLink from "@share/common/BannerLink.vue";
import Segments, {SegmentItem} from "@share/common/Segments.vue";
import i18n from "@service/locale/i18";
import { CommentViewModes } from "@api/enums/CommentViewModes";
import ToggleButton from "@common/vue-toggle-btn/toggle-btn.vue";

@Component({
    name: "ObjectSidebar",
    components: {Segments, BannerLink, ToggleButton}
})
export default class ObjectSidebar extends Vue {
    @Prop({default: false}) showPeople: boolean;
    @Prop({ default: false }) showQuestionToggler: boolean;

    currentPanelTab: MeetingPanelTabs = MeetingPanelTabs.chat;
    CommentViewModes = CommentViewModes;

    segments: SegmentItem[] = [
        {
            key: MeetingPanelTabs.chat,
            title: i18n.t("web-conferences.chat") as string
        },
        {
            key: MeetingPanelTabs.participantsControls,
            title: i18n.t("web-conferences.people") as string
        }
    ];

    get getShowQuestionToggler() {
        return this.showQuestionToggler && this.showPeople && this.comments;
    }

    get comments() {
        return this.$children.find(item => item && item?.$vnode?.componentOptions?.tag == 'comments');
    }

    get showCommentsTab() {
        return this.currentPanelTab == MeetingPanelTabs.chat;
    }

    get showPeopleTab() {
        return this.currentPanelTab == MeetingPanelTabs.participantsControls;
    }

    onChangeTab(newTab: SegmentItem) {
        this.currentPanelTab = newTab.key;
    }

}
